// Thema's (feat/themas), zie themesApp.nl.ts.
export const appThemesDe = {
    audience: 'Design dieses Boards',
    audienceHint: 'Später unter Tablets änderbar oder am Board selbst mit Anpassen (auch pro Bildschirm).',
    adult: 'Familie und Erwachsene',
    adultHint: 'Design Erwachsene: ruhig und klar, neutrale Farben und Liniensymbole.',
    kids: 'Kinder',
    kidsHint: 'Design Kinder: bunte Symbole, größere Tasten und Schrift. Steht das Board im Kinderzimmer, zeigt es nur ihre Sachen.',
    pictos: 'Symbole in der App',
    pictosHint: 'Gilt auf diesem Gerät.',
    pictosClean: 'Klar (ruhige Linien)',
    pictosColor: 'Verspielt (bunt)',
};
//# sourceMappingURL=themesApp.de.js.map